// extracted by mini-css-extract-plugin
export default {"truncate":"cZOpih4Hd1ota5ZmlLFu","truncateLineClamp":"KMGejHxtYWM9c4FtyELY","truncateExpanded":"UBaKNXWvuc3yWfZCuOvg"};